export default {
  ChooseFile: 'انتخاب فایل',
  Uploading: 'در حال آپلود',
  AreYouSureToRemoveThisFile: 'آیا از حذف این فایل اطمینان دارید؟',
  HasError: 'خطای اعتبارسنجی!',
  File_max_size_exceeded:
    'حجم فایل "{fileName}" بیشتر از حد مجاز است. فایل هایی با حجمی کمتر از {maxSize} کیلو بایت آپلود کنید.',
  File_extension_not_accepted:
    'نوع فایل "{fileName}" پذیرفته نیست. نوع های قابل پذیرش "{accepted}" است.',
  jalaliCal: 'تقویم شمسی',
  gregorianCal: 'تقویم میلادی',
  Preview: 'پیش نمایش',
  today: 'امروز',
  tomorrow: 'فردا',
  yesterday: 'دیروز',
  lastWeekDay: 'dddd [گذشته]',
  noTimeSelected: 'زمان انتخاب نشده است',
  squareImageError: {
    single: 'طول و عرض تصویر باید یکسان باشد',
    multiple:
      'یک یا چند عدد از تصاویر عرض و طول یکسان نداشته و قابل انتخاب نیستند'
  },
  uploadCountLimit:
    'تعداد فایل های انتخابی باید کمتر یا مساوی {count} عدد باشد',
  countOfItemsFound: '{count} مورد یافت شد',
  notFilterDescription: {
    enable: 'غیرفعال کردن حالت معکوس (not)',
    disable: 'فعال کردن حالت معکوس (not)'
  },
  loading: 'درحال بارگیری ...',
  applyFilter: 'اعمال فیلتر',
  removeFilters: 'حذف فیلتر ها',
  excelExport: 'خروجی اکسل',
  searchCourier: 'جستجوی باربری',
  search: 'جستجو',
  searchUser: 'جستجوی کاربر',
  choose: 'انتخاب کنید ...',
  clientType: 'نوع کلاینت',
  lastUpdate: 'آخرین بروزرسانی',
  nothingFound: 'موردی یافت نشد',
  bulkImport: 'افزودن انبوه',
  sampleFile: 'فایل نمونه',
  excelFile: 'فایل اکسل',
  saveChanges: 'ذخیره تغییرات',
  dateRangeRequired: 'انتخاب بازه تاریخ الزامی است!',
  files: 'فایل ها'
}
